import React from "react";
import { COLORS } from "../../../common/consts/colors";
import type { IconProps } from "./type";

const ArrowUpIcon = ({ color = "offWhite" }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M17 14L12 9L7 14"
        stroke={COLORS[color]}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ArrowUpIcon;
